import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";
import { FormControl, MenuItem, Select } from "@mui/material";
import { changeFilter } from "app/store/dashboard/patient_compliance_analytic/slice/patientComplianceAnalyticSlice";

const PatientComplianceAnalyticYearlyFilter = () => {
  const dispatch = useDispatch();
  const { yearlyFilter } = useSelector(
    (state) => state.patientComplianceAnalytic
  );

  return (
    <FormControl>
      <Select
        disableUnderline
        value={yearlyFilter}
        onChange={(e) =>
          dispatch(
            changeFilter({
              type: "yearlyFilter",
              value: e.target.value,
            })
          )
        }
        IconComponent={KeyboardArrowDownIcon}
        variant="standard"
        sx={{
          ".MuiSelect-standard": {
            background: "transparent",
            marginRight: "10px",
          },
          ".MuiSelect-select": {
            color: "#94BA33",
            fontSize: "0.875rem",
            fontWeight: 500,
            padding: "4px 8px",
            backgroundColor: "transparent",
          },
          "&::focus": {
            background: "transparent !important",
          },
          ".MuiSelect-icon": {
            color: "#94BA33",
          },
        }}
      >
        <MenuItem value="current_year">Current Year</MenuItem>
        <MenuItem value="last_two_years">Last 2 Years</MenuItem>
        <MenuItem value="last_three_years">Last 3 Years</MenuItem>
      </Select>
    </FormControl>
  );
};

export default PatientComplianceAnalyticYearlyFilter;
